<template>
  <v-container v-if="variant">
    <v-row class="mb-4 ga-4">
      <v-col
        class="bordered bg-white ml-n2"
        cols="6">
        <SiteSpecificSurcharges
          :location-id="locationId"
          :part-id="nodeId" />
      </v-col>
      <v-col
        class="bordered bg-white mr-n2"
        cols="6">
        <ProductSpecificSurcharges
          :node-id="nodeId"
          :variant="variant" />
      </v-col>
    </v-row>
    <v-row class="mt-4 ga-4">
      <v-col
        class="bordered bg-white ml-n2"
        cols="6">
        <ProfitSurcharge
          :node-id="nodeId"
          :variant="variant" />
      </v-col>
      <v-col
        class="bordered bg-white mr-n2"
        cols="6">
        <PositionCost :variant="variant" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

import SiteSpecificSurcharges from "./SurchargeCashSalePriceParts/SiteSpecificSurcharges.vue";
import ProductSpecificSurcharges from "./SurchargeCashSalePriceParts/ProductSpecificSurcharges.vue";
import ProfitSurcharge from "./SurchargeCashSalePriceParts/ProfitSurcharge.vue";
import PositionCost from "./SurchargeCashSalePriceParts/PositionCost.vue";

import { useSpaceStore } from "../../../../stores/spaceStore";
import { useTreeStore } from "@/stores/treeStore";

const spaceStore = useSpaceStore();
const treeStore = useTreeStore();

const variant = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const locationId = computed(() => {
  return treeStore.elementLocation[props.nodeId];
});

onMounted(() => {
  variant.value = spaceStore.getElement(props.nodeId);
});
</script>

<style lang="scss">
.table_variant_surcharge {
  font-size: 85%;

  //.wide_col {
  // max-width: 60%;
  // min-width: 30%;
  //}

  .input_col {
    // width: 120px;
    padding: 0 6px !important;

    .v-field__input {
      min-height: 10px !important;
    }
  }

  .perc_col {
    width: 10px;
    padding: 0 6px !important;
  }

  .e_per_piece_col {
    width: 30px;
    padding: 0 6px !important;
    white-space: nowrap;
  }

  td,
  th {
    border-bottom: none !important;
  }

  .low-height {
    td,
    th {
      height: 40px !important;
    }
  }

  .v-field__input {
    padding: 4px 8px !important;
  }
}
</style>
